import { EnvironmentModel } from '@libs/shared/common';
import { RemoteServices } from '../backend';
import { grafanaFaroConfig } from '../grafana-faro';
import { version } from './version';

const bffBaseUrl: string = 'https://bff.dev.lekkerland.io';

export const environmentDev: EnvironmentModel = {
  type: 'dev',
  production: true,
  links: {
    appUrl: '',
    deliveryTracking: 'https://srmde.www.stag.lekkerland.c.korekontrol.net/lieferung/meine-lieferungen',
    whatsAppNewsletter: 'https://www.lekkerland.de/whatsapp',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.lekkerland.cep&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1',
  },
  bff: {
    url: bffBaseUrl,
    services: RemoteServices,
  },
  consentConfig: {
    settingId: 'mY27W8tD0US9kw',
    version: 'preview',
  },
  liveUpdateUrl: 'https://assets.stage.lekkerland.io/cep/',
  appVersion: version,
  msalConfig: {
    clientId: '58104e5e-6671-4bb0-9d91-4c7be4daa174',
    redirectUri: 'https://app.dev.lekkerland.io/auth',
    tenantId: 'llsso.onmicrosoft.com',
    authorityHostname: 'llsso.b2clogin.com',
    androidHash: 'yayxbYcaLoPo7V6zavOL6eoYNwA%3D',
    signInPolicy: 'B2C_1A_signin_default',
    signUpPolicy: 'B2C_1A_signup_only',
    resetPasswordPolicy: 'B2C_1A_PasswordReset',
    appId: 'com.lekkerland.cep.dev',
    iosAppStoreId: '6450741880',
  },
  msalLekkerlandDirectoryUserConfig: {
    clientId: '9a8cdc55-d1b5-475f-b386-863f32a47b9b',
    tenantId: '66012673-85f8-456b-bd8d-b234a2507c99',
    signInPolicy: 'oauth2/v2.0/authorize',
    signUpPolicy: '',
    authorityHostname: 'login.microsoftonline.com',
    redirectUri: 'https://app.dev.lekkerland.io/agent-login',
    androidHash: '',
    resetPasswordPolicy: '',
    appId: '',
    iosAppStoreId: '',
  },
  grafanaFaroConfig,
};
